export const Link = {
  link: {
    variants: {
      variant: {
        plain: {
          color: "#9855d4",
          _focus: {
            outline: "none",
            shadow: "none",
          },
        },
      },
    },
  },
};
